import creator from '../helpers/creator'
import Animate from './Animate'
import Tabs from './Tabs'
import Search from './Search'
import Token from './Token'
import OverlayLayer from "./OverlayLayer"
import Parallax from './Parallax'
import { initOverlaySlider } from './overlay/slider'
import { renderMiniHeader, setMiniHeaderTheme, syncPaginationBullets } from './overlay/headerMini'
import { overlayDebugError, overlayDebugLog, overlayDebugWarn } from '../helpers/overlayDebug'

class FetchWithParam {
  constructor() {
    this.windowRef = window.location.href
    this.overlay = null
    this.id = 0
    this.hash = 0
    this.events = []
    this.url = null
    this.cookie = window.token.getCookie('DIOR_GM_30')
    this.initialize()

  }

  initialize() {
    if(this.windowRef.includes('?url') && this.cookie != '') {
      this.getData()
      this.bindEvents()
    } else {
      window.token = new Token()
    }
  }

  bindEvents() {
    window.addEventListener('fetch:done', () => {
      window.overlaylayer = new OverlayLayer(this.id, this.hash)
      this.createSlider(window.overlaylayer)
    })
  }

  getData() {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    const page_slug = urlParams.get('url')
    const page_id = urlParams.get('id')
    this.hash = window.location.hash
    this.id = `parent-${page_id}`

    const subpageId = this.hash.replace('#page-', '')

    this.fetchData(page_slug, subpageId)
  }

  isErrorResponse(html, response) {
    if (!response.ok) {
      return true
    }
    if (typeof html !== 'string') {
      return true
    }
    const normalized = html.toLowerCase()
    return (
      normalized.includes('503 service unavailable') ||
      normalized.includes('service unavailable') && normalized.includes('apache') ||
      normalized.includes('502 bad gateway') ||
      normalized.includes('504 gateway timeout') ||
      normalized.includes('internal server error') ||
      normalized.includes('page error')
    )
  }

  async fetchData(url, subid) {
    let myHeaders = new Headers()
    myHeaders.append("x-custom-provider", "dior-montaigne")
    let lang = window.location.pathname.split('/')[1]
    if (lang) {
      this.url = `${window.location.origin}/${lang}/${url}`
    } else {
      this.url = `${window.location.origin}/${url}`
    }

    try {
      const response = await fetch(this.url, { headers: myHeaders })
      overlayDebugLog('FetchWithParam réponse', {
        source: 'FetchWithParam',
        marker: 'FETCH_SOURCE=FetchWithParam',
        id: subid,
        url: this.url,
        ok: response.ok,
        status: response.status,
        redirected: response.redirected,
      })

      const html = await response.text()
      const overlay = document.querySelector(`.js-overlay-child[data-id="${subid}"]`)

      if (this.isErrorResponse(html, response)) {
        overlayDebugWarn('FetchWithParam réponse ignorée (HTTP ou page erreur)', {
          source: 'FetchWithParam',
          id: subid,
          url: this.url,
          status: response.status,
        })
        if (overlay) {
          overlay.innerHTML = ''
          overlay.dataset.fetchStatus = String(response.status || 'error')
        }
        return
      }

      const parser = new DOMParser()
      const doc = parser.parseFromString(html, 'text/html')

      const bodyNode = doc.querySelector('body')
      let content = bodyNode ? bodyNode.innerHTML : ''
      if (!content.trim()) {
        overlayDebugWarn('FetchWithParam body vide', {
          source: 'FetchWithParam',
          id: subid,
          url: this.url,
        })
      }
      if (!overlay) {
        overlayDebugWarn('FetchWithParam cible introuvable', {
          source: 'FetchWithParam',
          id: subid,
        })
        return
      }
      overlay.innerHTML = content
      delete overlay.dataset.fetchStatus

      window.tabs = creator('.js-tabs', Tabs)
      window.search = new Search()

      if (window.tabs.length > 4) {
        const event = new CustomEvent("fetch:done")

        setTimeout(() => {
          window.dispatchEvent(event)
        }, 300)
      }
    } catch (err) {
      overlayDebugError('FetchWithParam échec', { source: 'FetchWithParam', id: subid, url: this.url }, err)
      console.error('Failed to fetch one or more of these URLs:');
      console.error(err);
    }
  }

  createSlider(overlay) {
    let stickyHeader = document.querySelector('.js-overlay-header-mini')
    let slider = overlay.ui.$overlay.querySelector('.js-slider') 
    if (window.sliderdefault) {
      window.sliderdefault.destroy()
      window.sliderdefault = undefined
    }

    window.sliderdefault = initOverlaySlider(slider, {
      swiperOptions: {
        observer: true,
        threshold: 20,
      },
    })
    let hash = window.location.hash.substring(1)
    let slide = slider.querySelector('[data-hash="'+hash+'"]')
    let index = slide.getAttribute('data-index')
    window.sliderdefault.activeIndex = parseInt(index)
    window.sliderdefault.realIndex = parseInt(index)
    window.sliderdefault.updateAutoHeight(300)
    let activeSlide = window.sliderdefault.slides[window.sliderdefault.activeIndex]

    let overlayClose = activeSlide.querySelector('.js-overlay-close')
    let overlayTitle = activeSlide.querySelector('.js-overlay-title')
    let overlayPagination = activeSlide.querySelector('.js-pagination')

    if(!stickyHeader.hasChildNodes()) {
      const { pagination } = renderMiniHeader(stickyHeader, {
        closeEl: overlayClose,
        titleEl: overlayTitle,
        paginationEl: overlayPagination,
      })
      syncPaginationBullets(pagination, window.sliderdefault.activeIndex)
    }

    let images = activeSlide.querySelectorAll('.js-parallax')
    if (images.length > 0) {
      window.parallax = new Parallax(images)
    }

    setMiniHeaderTheme(stickyHeader, activeSlide)

    window.animate = new Animate()

    let id = activeSlide.querySelector('.js-overlay-child').getAttribute('data-id')
    let pathUrl

    window.fetchdata.items.forEach(item => {
      if (item.id == id) {
        pathUrl = new URL(item.url)
      }
    });
  }
}

export default FetchWithParam
